/**
 * Pixelgipfel cart engine:
 * - AJAX add-to-cart from the PDP form -> opens the "Im Warenkorb" modal
 * - Qty steppers + remove on the cart page (Section Rendering API re-render)
 * - Cross-sell "+ Dazu" buttons (cart page + modal) with toast feedback
 * - Gipfelwacht warranty radio (adds/removes gw/gws products via update.js)
 * - Dispatches pg:cart-updated so the header pill stays in sync
 */
(function () {
  'use strict';

  var toastTimer = null;

  function str(key, fallback) {
    return (window.pgStrings && window.pgStrings[key]) || fallback;
  }

  function formatMoney(cents) {
    if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.formatMoney === 'function') {
      try {
        return window.Shopify.formatMoney(cents, window.moneyFormat || "CHF {{amount_with_apostrophe_separator}}");
      } catch (_) {}
    }
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    return 'CHF ' + parts.join('.');
  }

  function dispatchCart(cart) {
    document.dispatchEvent(new CustomEvent('pg:cart-updated', { detail: cart }));
  }

  function getCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        dispatchCart(cart);
        return cart;
      });
  }

  /* ---------- cart page section re-render ---------- */

  function cartRoot() {
    return document.querySelector('[data-pg-cart-section]');
  }

  function setBusy(state) {
    var root = cartRoot();
    if (root) root.setAttribute('aria-busy', state ? 'true' : 'false');
  }

  function renderCartSection(sections) {
    var root = cartRoot();
    if (!root || !sections) return;
    var id = root.getAttribute('data-section-id');
    var html = sections[id];
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-pg-cart-section]');
    if (fresh) root.replaceWith(fresh);
  }

  function withSections(body) {
    var root = cartRoot();
    if (root) body.sections = root.getAttribute('data-section-id');
    return body;
  }

  /* ---------- mutations ---------- */

  function changeLine(line, quantity) {
    setBusy(true);
    var body = withSections({ line: line, quantity: quantity });
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.sections) renderCartSection(cart.sections);
        dispatchCart(cart);
        syncModalState(cart);
        return cart;
      })
      .finally(function () { setBusy(false); });
  }

  function addVariant(variantId, opts) {
    opts = opts || {};
    setBusy(true);
    var body = withSections({ items: [{ id: Number(variantId), quantity: 1 }] });
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status !== 200) {
          showToast(res.description || str('addError', 'Konnte nicht hinzugefügt werden.'), '');
          return getCart();
        }
        if (res.sections) renderCartSection(res.sections);
        if (opts.toastName) showToast(opts.toastName, str('toastSuffix', 'ist im Warenkorb'));
        return getCart().then(function (cart) {
          syncModalState(cart);
          return cart;
        });
      })
      .finally(function () { setBusy(false); });
  }

  function setWarranty(pick, listEl) {
    var gwId = listEl.getAttribute('data-gw-variant');
    var gwsId = listEl.getAttribute('data-gws-variant');
    var updates = {};
    if (gwId) updates[gwId] = pick === 'gw' ? 1 : 0;
    if (gwsId) updates[gwsId] = pick === 'gws' ? 1 : 0;
    var body = withSections({ updates: updates });
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.sections) renderCartSection(cart.sections);
        dispatchCart(cart);
        syncModalState(cart);
        return cart;
      });
  }

  /* ---------- toast ---------- */

  function showToast(name, suffix) {
    var toast = document.querySelector('[data-pg-toast]');
    if (!toast) return;
    var nameEl = toast.querySelector('[data-pg-toast-name]');
    var suffixEl = toast.querySelector('[data-pg-toast-suffix]');
    if (nameEl) nameEl.textContent = name;
    if (suffixEl) suffixEl.textContent = suffix || '';
    toast.hidden = false;
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 3500);
  }

  /* ---------- add-modal ---------- */

  function modalEl() {
    return document.querySelector('[data-pg-addmodal]');
  }

  function openModal(item, form) {
    var modal = modalEl();
    if (!modal) {
      showToast(item.product_title || str('itemFallback', 'Artikel'), str('toastSuffix', 'ist im Warenkorb'));
      return;
    }

    var photo = modal.querySelector('[data-pg-addmodal-photo]');
    if (photo) {
      photo.textContent = '';
      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = item.product_title || '';
        photo.appendChild(img);
      } else {
        photo.textContent = str('image', 'Bild');
      }
    }

    var nameEl = modal.querySelector('[data-pg-addmodal-name]');
    if (nameEl) nameEl.textContent = item.product_title || item.title || '';

    /* A1: gewählte Variante (z.B. «Grösse: L») unter dem Produktnamen —
       nur bei Nicht-Default-Varianten. pg-pdp.js pflegt data-pg-variant-title
       am Formular; Fallback: variant_title aus der Cart-API. */
    var sub = (form && form.dataset.pgProductSub) || '';
    var variantLabel = (form && form.dataset.pgVariantTitle) || '';
    if (!variantLabel && item.variant_title && item.variant_title !== 'Default Title') {
      variantLabel = item.variant_title;
    }
    if (variantLabel) sub = sub ? sub + ' · ' + variantLabel : variantLabel;
    var subEl = modal.querySelector('[data-pg-addmodal-sub]');
    if (subEl) subEl.textContent = sub;

    var priceEl = modal.querySelector('[data-pg-addmodal-price]');
    if (priceEl) priceEl.textContent = formatMoney(typeof item.final_price === 'number' ? item.final_price : item.price || 0);

    var warranty = modal.querySelector('[data-pg-warranty]');
    if (warranty) warranty.hidden = !(form && form.dataset.pgIsPc === 'true');

    // Hardware-Garantie + Lieferung nur bei PC-Produkten
    var isPc = form && form.dataset.pgIsPc === 'true';
    var hwWarranty = modal.querySelector('[data-pg-hw-warranty]');
    var delivery = modal.querySelector('[data-pg-delivery]');
    if (hwWarranty) hwWarranty.hidden = !isPc;
    if (delivery) delivery.hidden = !isPc;

    if (isPc && item && (item.final_price || item.price)) {
      var base = item.final_price || item.price;
      var p3 = Math.ceil((base * 0.07) / 1000) * 10; // 7% in Franken auf 10er gerundet
      var p5 = Math.ceil((base * 0.13) / 1000) * 10; // 13% in Franken auf 10er gerundet
      var p3El = modal.querySelector('[data-pg-warranty-3-price]');
      var p5El = modal.querySelector('[data-pg-warranty-5-price]');
      if (p3El) p3El.textContent = 'CHF ' + p3.toLocaleString('de-CH') + '.–';
      if (p5El) p5El.textContent = 'CHF ' + p5.toLocaleString('de-CH') + '.–';
      // Prices als data-Attribute speichern (in Rappen für Konsistenz)
      var opt3 = modal.querySelector('[data-pg-warranty-pick="3"]');
      var opt5 = modal.querySelector('[data-pg-warranty-pick="5"]');
      if (opt3) opt3.setAttribute('data-pg-warranty-price', String(p3 * 100));
      if (opt5) opt5.setAttribute('data-pg-warranty-price', String(p5 * 100));
      // Versand: ehrliche Schätzung ab CHF 9.– (A-/B-Post), der Checkout rechnet exakt.
      var shipOpt = modal.querySelector('[data-pg-delivery-pick="ship"]');
      var shipEl = modal.querySelector('[data-pg-ship-price]');
      if (shipOpt) {
        shipOpt.setAttribute('data-pg-delivery-price', '900');
        if (shipEl) shipEl.textContent = 'ab CHF 9.–';
      }
    }

    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var closeBtn = modal.querySelector('[data-pg-addmodal-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    var modal = modalEl();
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.documentElement.style.overflow = '';
  }

  /**
   * PLZ → Preis via Railway-Backend (Google Maps Distance Matrix).
   * Backend rechnet: Basis-Fee + (Hin + Rück + Aufbau) × Stundensatz.
   * Cap bei 60 km / 90 Min pro Weg → "Preis auf Anfrage".
   */
  var DELIVERY_QUOTE_URL = (window.pgDeliveryApi || 'https://api.pixelgipfel.ch') + '/delivery/quote';
  var _deliveryCache = {};

  function fetchDeliveryQuote(plz) {
    if (_deliveryCache[plz]) return Promise.resolve(_deliveryCache[plz]);
    var p = String(plz || '').trim();
    if (!/^\d{4}$/.test(p)) return Promise.resolve(null);
    return fetch(DELIVERY_QUOTE_URL + '?to=' + encodeURIComponent(p))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (data) _deliveryCache[plz] = data;
        return data;
      })
      .catch(function () { return null; });
  }

  /**
   * Aktuellen Modal-Zustand als Line-Item-Properties zurückgeben (für Add-to-Cart).
   */
  function pgAddOnProperties() {
    var modal = modalEl();
    if (!modal || modal.hidden) return {};
    var props = {};
    var wOpt = modal.querySelector('[data-pg-warranty-pick][aria-checked="true"]');
    if (wOpt) {
      var years = wOpt.getAttribute('data-pg-warranty-pick');
      if (years && years !== '2') {
        var price = parseInt(wOpt.getAttribute('data-pg-warranty-price'), 10) || 0;
        props['Garantie'] = years + ' Jahre (+CHF ' + Math.round(price / 100) + '.–)';
      }
    }
    var dOpt = modal.querySelector('[data-pg-delivery-pick][aria-checked="true"]');
    if (dOpt) {
      var kind = dOpt.getAttribute('data-pg-delivery-pick');
      if (kind === 'ship') {
        var shipPrice = parseInt(dOpt.getAttribute('data-pg-delivery-price'), 10) || 0;
        props['Versand'] = 'Versand (Kosten gemäss Checkout)';
      } else if (kind === 'install') {
        var plz = (modal.querySelector('[data-pg-plz]') || {}).value || '';
        var zone = zoneFromPlz(plz);
        if (zone) props['Aufbau vor Ort'] = 'PLZ ' + plz + ' — ' + zone.label;
      }
    }
    return props;
  }

  function updateCartAttributes() {
    var modal = modalEl();
    if (!modal) return;
    var plzInput = modal.querySelector('[data-pg-plz]');
    var plzResult = modal.querySelector('[data-pg-plz-result]');
    var installOpt = modal.querySelector('[data-pg-delivery-pick="install"]');
    var installPriceEl = modal.querySelector('[data-pg-install-price]');
    if (!plzInput || !installOpt) return;

    var plz = plzInput.value.trim();
    if (!/^\d{4}$/.test(plz)) {
      if (installPriceEl) installPriceEl.textContent = 'ab CHF 149.–';
      if (plzResult) { plzResult.textContent = plz ? 'PLZ muss 4 Ziffern haben' : 'PLZ eingeben für genauen Preis'; plzResult.setAttribute('data-state', 'out'); }
      return;
    }

    if (plzResult) { plzResult.textContent = 'Berechne Fahrzeit…'; plzResult.setAttribute('data-state', 'out'); }

    fetchDeliveryQuote(plz).then(function (data) {
      if (!data) {
        if (installPriceEl) installPriceEl.textContent = 'ab CHF 149.–';
        if (plzResult) { plzResult.textContent = 'Preis konnte nicht berechnet werden'; plzResult.setAttribute('data-state', 'out'); }
        return;
      }
      if (data.cap_exceeded) {
        if (installPriceEl) installPriceEl.textContent = 'Auf Anfrage';
        installOpt.setAttribute('data-pg-delivery-price', '0');
        installOpt.setAttribute('data-pg-delivery-note', data.note || 'Ausserhalb Region');
        if (plzResult) {
          plzResult.innerHTML = '<strong>Ausserhalb 60 km</strong> — Preis auf Anfrage. Fahrzeit ' + data.duration_min_one_way + ' Min pro Weg.';
          plzResult.setAttribute('data-state', 'out');
        }
        return;
      }
      var priceRp = data.price_chf * 100;
      installOpt.setAttribute('data-pg-delivery-price', String(priceRp));
      if (installPriceEl) installPriceEl.textContent = data.price_display;
      if (plzResult) {
        var det = [data.zone];
        if (data.distance_km != null) det.push(data.distance_km + ' km');
        det.push(data.duration_min_one_way + ' Min pro Weg');
        det.push('Total ' + data.roundtrip_min + ' Min mit Aufbau');
        plzResult.innerHTML = det.join(' · ');
        plzResult.removeAttribute('data-state');
      }
    });
  }

  function syncModalState(cart) {
    var modal = modalEl();
    if (!modal || !cart || !cart.items) return;

    var variantIds = cart.items.map(function (i) { return String(i.variant_id); });
    var productIds = cart.items.map(function (i) { return String(i.product_id); });

    // Warranty radio state
    var list = modal.querySelector('[data-pg-warranty] [role="radiogroup"]');
    if (list) {
      var gwId = list.getAttribute('data-gw-variant');
      var gwsId = list.getAttribute('data-gws-variant');
      var sel = 'none';
      if (gwsId && variantIds.indexOf(gwsId) !== -1) sel = 'gws';
      else if (gwId && variantIds.indexOf(gwId) !== -1) sel = 'gw';
      list.querySelectorAll('[data-pg-gw-pick]').forEach(function (opt) {
        opt.setAttribute('aria-checked', opt.getAttribute('data-pg-gw-pick') === sel ? 'true' : 'false');
      });
    }

    // Cross-sell rows
    modal.querySelectorAll('.pg-addmodal__upsell-row').forEach(function (row) {
      var inCart = productIds.indexOf(row.getAttribute('data-product-id')) !== -1;
      row.setAttribute('data-in-cart', inCart ? 'true' : 'false');
      var btn = row.querySelector('[data-pg-add]');
      if (btn) {
        btn.textContent = inCart ? str('inCart', '✓ Im Korb') : str('add', '+ Dazu');
        btn.disabled = inCart;
      }
    });

    // Footer total
    var totalEl = modal.querySelector('[data-pg-addmodal-total]');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price || 0);
  }

  /* ---------- event delegation ---------- */

  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-pg-qty-change]');
    if (qtyBtn) {
      var delta = parseInt(qtyBtn.getAttribute('data-pg-qty-change'), 10) || 0;
      var line = parseInt(qtyBtn.getAttribute('data-line'), 10);
      var qty = (parseInt(qtyBtn.getAttribute('data-qty'), 10) || 0) + delta;
      if (qty < 0) qty = 0;
      changeLine(line, qty);
      return;
    }

    var removeBtn = e.target.closest('[data-pg-remove]');
    if (removeBtn) {
      changeLine(parseInt(removeBtn.getAttribute('data-line'), 10), 0);
      return;
    }

    var addBtn = e.target.closest('[data-pg-add]');
    if (addBtn && !addBtn.disabled) {
      addVariant(addBtn.getAttribute('data-variant-id'), {
        toastName: addBtn.getAttribute('data-product-title') || ''
      });
      return;
    }

    var gwBtn = e.target.closest('[data-pg-gw-pick]');
    if (gwBtn) {
      var group = gwBtn.closest('[role="radiogroup"]');
      if (group) setWarranty(gwBtn.getAttribute('data-pg-gw-pick'), group);
      return;
    }

    var hwBtn = e.target.closest('[data-pg-warranty-pick]');
    if (hwBtn) {
      hwBtn.closest('[data-pg-warranty-group]').querySelectorAll('[data-pg-warranty-pick]').forEach(function (o) {
        o.setAttribute('aria-checked', o === hwBtn ? 'true' : 'false');
      });
      updateCartAttributes();
      return;
    }

    var delBtn = e.target.closest('[data-pg-delivery-pick]');
    if (delBtn) {
      delBtn.closest('[data-pg-delivery-group]').querySelectorAll('[data-pg-delivery-pick]').forEach(function (o) {
        o.setAttribute('aria-checked', o === delBtn ? 'true' : 'false');
      });
      var pick = delBtn.getAttribute('data-pg-delivery-pick');
      var modal = modalEl();
      var plzWrap = modal ? modal.querySelector('[data-pg-plz-wrap]') : null;
      if (plzWrap) plzWrap.hidden = pick !== 'install';
      updateCartAttributes();
      return;
    }

    if (e.target.closest('[data-pg-addmodal-close]')) {
      closeModal();
      return;
    }

    // Beim Klick auf "Zum Warenkorb" die Add-Ons als Cart-Attribute anhängen
    var goCart = e.target.closest('.pg-addmodal__gocart');
    if (goCart) {
      var props = pgAddOnProperties();
      var keys = Object.keys(props);
      if (keys.length > 0) {
        e.preventDefault();
        var body = { attributes: {} };
        keys.forEach(function (k) { body.attributes[k] = props[k]; });
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        }).finally(function () { window.location = goCart.getAttribute('href'); });
      }
      return;
    }

    var modal = modalEl();
    if (modal && !modal.hidden && e.target === modal) closeModal();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  // PDP add-to-cart: intercept and show the modal instead of navigating
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-pg-ajax-add]');
    if (!form) return;
    e.preventDefault();
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        if (item.status && item.status !== 200) {
          showToast(item.description || str('addError', 'Konnte nicht hinzugefügt werden.'), '');
          return getCart();
        }
        openModal(item, form);
        return getCart().then(syncModalState);
      })
      .catch(function () {
        // Fall back to native submit on network failure
        form.removeAttribute('data-pg-ajax-add');
        form.submit();
      })
      .finally(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
  });

  // PLZ-Input im Add-Modal: bei jedem Tippen Zone neu berechnen
  document.addEventListener('input', function (e) {
    var plzInput = e.target.closest('[data-pg-plz]');
    if (plzInput) updateCartAttributes();
  });

  // Initial header sync (covers back/forward-cache stale counts)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { getCart(); });
  } else {
    getCart();
  }
})();
